import { clsx } from 'clsx'
import React, { forwardRef } from 'react'

const styles = {
  base: [
    // Basic layout
    'relative isolate',
  ],
  size: {
    xs: 'text-xs/4',
    sm: 'text-sm/5',
    md: 'text-sm/6',
    lg: 'text-base/7',
    xl: 'text-lg/8',
    '2xl': 'text-xl/8',
    '3xl': 'text-2xl/9',
    '4xl': 'text-3xl/10',
    '5xl': 'text-4xl/11',
    '6xl': 'text-5xl/12',
  },
  color: {
    default: 'text-gray-900 dark:text-white',
    muted: 'text-gray-500 dark:text-gray-400',
    inverted: 'text-white dark:text-gray-900',
  },
  weight: {
    normal: 'font-normal',
    medium: 'font-medium',
    semibold: 'font-semibold',
    bold: 'font-bold',
  },
}

export const Text = forwardRef(function Text(
  {
    as: Component = 'p',
    className,
    size = 'md',
    color = 'default',
    weight = 'normal',
    ...props
  }: {
    as?: React.ElementType
    className?: string
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl'
    color?: 'default' | 'muted' | 'inverted'
    weight?: 'normal' | 'medium' | 'semibold' | 'bold'
  } & React.ComponentPropsWithoutRef<'p'>,
  ref: React.ForwardedRef<HTMLParagraphElement>
) {
  return (
    <Component
      {...props}
      className={clsx(
        styles.base,
        styles.size[size],
        styles.color[color],
        styles.weight[weight],
        className
      )}
      ref={ref}
    />
  )
})
